//Web3Section2

// src/components/Web3Section2.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:50%;
  margin: 0 auto;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 5% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  margin-top:0px;
  align-self: flex-start;
  padding:1% 0% 0% 0%;
  
  @media (max-width: 500px) {
    align-self: center;
    width:80%;
    text-align: center;
    padding:10% 0% 0% 0%;
    
  }
  
`;

const Title = styled.h2`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-top:0px;

  span{
    color: #FFF56A;
  }

  @media (max-width: 500px){
    font-size: 32px;
    line-height: 46px;
    margin-bottom:1%;;
  }

`;

const RightColumn = styled.div`
  flex: 6; 
  width:60%;
  overflow: hidden;
  padding:0% 0% 0% 5%;


  p {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;

    color: #EFEFEF;
  }

  @media (max-width: 500px) {
    
    width:100%;
    padding:0%;


    p {
      font-size: 14px;
      line-height: 24px;
      text-align:center;
    }

  }
  
`;




const Web3Section2 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Title>為甚麼需要web3<span>.</span></Title>
      </LeftColumn>
      <RightColumn>
        <p>隨著網際網路的演進， web1 的使用者指僅是資訊的單向接收者，進展到 web2 時期成為內容的發布者，而隨著區塊鏈技術等發展愈趨完備，web3 是去中心化，使用者自主的網際網路，使用者真正擁有自己的資料，擁有自己貢獻內容的所有權，並擁有自我主權身份 (Self-sovereign identity, SSI) 。web3 不僅賦予使用者更大的決策權，也提高了隱私與安全性。web3 代表了網際網路的典範轉移，強調使用者的賦能 (empowerment)、去中心化 (decentralisation)、信任 (trust) 和創新 (innovation)。web3 有潛力解決 web 2.0 相關的許多問題，為未來數位公民提供更加公平、具有隱私且安全的數位基礎。</p>
      </RightColumn>
    </SectionContainer>


  );
};

export default Web3Section2;
